<template>
  <div class="conversation-list" ref="conversationList" @scroll="handleScroll">
    <div v-for="(item,i) in state.messages" :key="i+'messages'" :id="item.clientMsgNo">
      <component :is="getComponent(item)" :item="item" @locate-message="locateMessage" :subscribers="state.subscribers" :key="JSON.stringify(item)"/>
    </div>
  </div>
</template>
<script>
  import {
    reactive,
    onMounted,
    nextTick,
    ref,
    onUnmounted,
    watch
  } from 'vue'
  import {
    useRouter,
    useRoute
  } from 'vue-router'
  // import {
  //   Toast
  // } from 'vant'
  import {
    useStore
  } from "vuex"
  import ItemText from './components/itemText.vue';
  import ItemTip from './components/itemTip.vue';
  import ItemImage from './components/itemImage.vue';
  import ItemTime from './components/itemTime.vue';
  import ItemRevoke from './components/itemRevoke.vue';
  import ItemDefault from './components/itemDefault.vue';
  import moment from 'moment';
  import {
    PullMode,
    Channel,
    ChannelTypeGroup,
    ChannelTypePerson,
    MessageStatus,
    MessageContentType,
  } from "wukongimjssdk";
  import WKSDK from "wukongimjssdk"
  import {
    MessageContentTypeConst
  } from "@/services/const.js";
  import BigNumber from "bignumber.js";
import { getQueryString } from '../../../utils/location';

  class TimeContent {
    constructor(timestamp) {
      this.timestamp = timestamp;
    }

    get contentType() {
      return MessageContentTypeConst.time;
    }
  }

  export default {
    name: 'conversationlist',
    components: {
      ItemText,
      ItemTip,
      ItemImage,
      ItemTime,
      ItemRevoke,
      ItemDefault,
    },
    props: ['subscribers'],
    setup(props) {
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const conversationList = ref(null)
      const state = reactive({
        token: store.state.imtoken,
        uid: store.state.imuid,
        // 频道id
        channelID: "",
        // 频道类型
        channelType: ChannelTypeGroup,
        // 消息列表
        messages: [],
        // 最小序列号消息
        minmessages: null,
        // 向下拉取结束
        pulldownFinished: false,
        // 订阅者
        subscribers: '',
      })
      // 监听subscribers变化
      watch(
        () => props.subscribers,
        (newVal) => {
          state.subscribers = newVal
        }, {
          deep: true,
          immediate: true
        } // 配置项
      );
      // 滚动到底部
      const scrollToBottom = () => {
        const chat = conversationList.value
        if (chat) {
          nextTick(function() {
            chat.scrollTop = chat.scrollHeight
          })
        }
      }
      // 滚动到指定位置
      const scrollToTargetId = (targetId, highlightTime = 1) => {
        const targetElement = document.getElementById(targetId);
        if (!targetElement) {
          console.error(`未找到元素`);
          return;
        }
        // 保存元素原有背景色（用于后续恢复）
        const originalBgColor = targetElement.style.backgroundColor || getComputedStyle(targetElement)
          .backgroundColor;
        // 获取目标元素的顶部偏移量
        const targetPosition = targetElement.offsetTop;
        // 滚动到目标位置
        const chat = conversationList.value
        if (chat) {
          nextTick(function() {
            chat.scrollTop = targetPosition - 72
          })
        }
        // 滚动完成后高亮元素（加延迟确保滚动动画完成）
        // 预估滚动动画时长（可根据实际需求调整）
        const scrollAnimationTime = 100;
        setTimeout(() => {
          // 设置红色背景
          targetElement.style.backgroundColor = 'rgb(18, 205, 176, 0.15)';

          // 5. 定时器：指定秒数后恢复原有背景色
          setTimeout(() => {
            targetElement.style.backgroundColor = originalBgColor;
          }, highlightTime * 1000); // 转换为毫秒
        }, scrollAnimationTime);
      }
      // 滚动到指定消息
      const locateMessage = (messageSeq) => {
        const message = findMessageWithMessageSeq(messageSeq)
        scrollToTargetId(message.clientMsgNo)
        console.log(message.clientMsgNo)
      }
      // 消息去重
      const distinctMessages = (messages) => {
        for (let i = 0; i < messages.length; i++) {
          for (let j = i + 1; j < messages.length; j++) {
            if (messages[i].clientMsgNo && messages[i].clientMsgNo !== '' && messages[i].clientMsgNo === messages[j]
              .clientMsgNo) {
              messages.splice(j, 1)
              j--;
            }
          }
        }
      }
      // 获取时间消息
      const getTimeMessage = (timestamp) => {
        const message = {}
        message.timestamp = timestamp
        message.clientMsgNo = timestamp.toString()
        message.content = new TimeContent(timestamp)
        return message
      }
      // 格式化时间
      const formatMessageTime = (message) => {
        return moment(message.timestamp * 1000).format('MM月DD日');
      }
      // 插入时间或历史消息分割线
      const insertTimeOrHistorySplit = (messages) => {
        const newMessages = new Array()
        // const shouldShowHistorySplit = this.shouldShowHistorySplit
        if (messages && messages.length > 0) {
          for (let i = 0; i < messages.length; i++) {
            const message = messages[i]
            if (newMessages.length === 0) {
              const timeMessage = getTimeMessage(message.timestamp)
              newMessages.push(timeMessage)
            } else {
              const preMessage = newMessages[newMessages.length - 1]
              if (preMessage.contentType !== MessageContentTypeConst.time && preMessage.contentType !==
                MessageContentTypeConst.historySplit && formatMessageTime(preMessage) !== formatMessageTime(
                  message)) {
                const timeMessage = getTimeMessage(message.timestamp)
                newMessages.push(timeMessage)
              }
            }
            newMessages.push(message)
            // if (shouldShowHistorySplit && this.initLocateMessageSeq > 0 && message.messageSeq === this
            //   .initLocateMessageSeq) {
            //   newMessages.push(new MessageWrap(this.getHistorySplit()))
            // }
          }
        }
        return newMessages
      }
      // 同步消息
      const getList = async () => {
        const msgs = await WKSDK.shared().chatManager.syncMessages(new Channel(state.channelID, state
          .channelType), {
          startMessageSeq: 0,
          endMessageSeq: 0,
          pullMode: PullMode.Up
        })
        if (msgs && msgs.length > 0) {
          state.minmessages = msgs[0]
        }
        state.messages = insertTimeOrHistorySplit(msgs)
        console.log('会话窗同步消息', state.messages)
        scrollToBottom()
        setTimeout(() => {
          scrollToBottom()
        }, 500)
      }
      // 向下拉取消息
      const pulldownList = async () => {
        if (state.minmessages.messageSeq === 1) { // 如果最小messageSeq=1 说明下拉没消息了直接return
          return
        }
        if (state.minmessages == null || state.minmessages.messageSeq <= 0) { // 没有消息直接return
          return
        }

        const msgs = await WKSDK.shared().chatManager.syncMessages(new Channel(state.channelID, state
          .channelType), {
          startMessageSeq: state.minmessages.messageSeq - 1,
          endMessageSeq: 0,
          pullMode: PullMode.Down
        })
        if (msgs.length <= 0 || state.minmessages.messageSeq === 1) {
          state.pulldownFinished = true
        } else {
          state.messages = [...insertTimeOrHistorySplit(msgs), ...state.messages]
          distinctMessages(state.messages)
          console.log('向下拉取消息', state.messages)
          nextTick(function() {
            const chat = conversationList.value
            const firstMsgEl = document.getElementById(state.minmessages.clientMsgNo)
            if (firstMsgEl) {
              chat.scrollTop = firstMsgEl.offsetTop
            }
            state.minmessages = msgs[0]
          })
        }

      }
      const isTopTriggered = ref(false);
      // 监听容器滚动
      const handleScroll = () => {

        if (!conversationList.value) return;

        // 获取容器滚动/尺寸属性
        const {
          scrollTop
        } = conversationList.value;

        //  触发「到顶部一定距离」的方法
        if (scrollTop <= 250) {
          if (!isTopTriggered.value) { // 避免重复触发
            isTopTriggered.value = true;
            if (state.pulldownFinished) {
              return false
            }
            pulldownList(); // 执行顶部触发逻辑
          }
        } else {
          isTopTriggered.value = false; // 离开阈值范围重置
        }

        //  触发「到底部一定距离」的方法
        // 关键公式：滚动位置 + 可视高度 ≥ 内容总高度 - 底部阈值
        // if (scrollTop + clientHeight >= scrollHeight - bottomThreshold.value) {
        //   if (!isBottomTriggered.value) { // 避免重复触发
        //     isBottomTriggered.value = true;
        //     handleBottomTrigger(); // 执行底部触发逻辑
        //   }
        // } else {
        //   isBottomTriggered.value = false; // 离开阈值范围重置
        // }
      }
      // 选择显示模板
      const getComponent = (item) => {
        // console.log(item?.remoteExtra?.revoke)
        if (item?.remoteExtra?.revoke) {
          return "ItemRevoke";
        } else {
          let type = item.content.contentType
          switch (type) {
            // 文本
            case MessageContentType.text:
              return "ItemText";
              // 图片
            case MessageContentType.image:
              return "ItemImage";
              // 时间
            case MessageContentTypeConst.time:
              return "ItemTime";
              // 提示
            default:
              if (type <= 2000 && type >= 1000) {
                return "ItemTip";
              } else {
                return "ItemDefault";
              }
          }
        }

      }
      const findElementById = (arr, fromUID) => {
        // find方法遍历数组，返回第一个满足条件的元素
        
        return arr.find(item => {
          if(item){
            return item.uid === fromUID
          }else{
            return null
          }
          
        });
      }
      // 监听消息方法
      const messageFunction = (message) => {
        console.log('监听消息', message)
        switch (message.contentType) {
          case MessageContentTypeConst.channelUpdate:
            WKSDK.shared().channelManager.fetchChannelInfo(message.channel);
            break;
          case MessageContentTypeConst.addMembers:
          case MessageContentTypeConst.removeMembers:
            WKSDK.shared().channelManager.syncSubscribes(message.channel);
            break;
        }
        if (!new Channel(state.channelID, state.channelType).isEqual(message.channel)) {
          return
        }
        // 查看订阅者信息
        const userextra = findElementById(state.subscribers, message.fromUID)
        // 插入扩展字段
        if (userextra) {
          message.user_extra = {
            avatar: userextra?.avatar,
            level: userextra?.orgData?.level||0,
            nickname: userextra?.nickname,
          }
        } else {
          message.user_extra = null
        }
        state.messages.push(message)
        scrollToBottom()
      }
      // 更新消息状态
      // updateMessageStatusBySendAck(ackPacket: SendackPacket) {
      //     const message = this.findMessageWithClientSeq(ackPacket.clientSeq)
      //     if (message) {
      //         message.message.messageID = ackPacket.messageID.toString()
      //         message.message.messageSeq = ackPacket.messageSeq
      //         if (ackPacket.reasonCode === 1) {
      //             this.updateLastMessageIfNeed(message)
      //             message.status = MessageStatus.Normal
      //             this.removeSendingMessageIfNeed(ackPacket.clientSeq, this.channel)
      //         } else {
      //             message.status = MessageStatus.Fail
      //             const sendingMessage = this.getSendingMessageWithClientMsgNo(message.clientMsgNo)
      //             if (sendingMessage) {
      //                 sendingMessage.reasonCode = ackPacket.reasonCode
      //                 this.fillOrder(sendingMessage)
      //             }

      //         }
      //         message.reasonCode = ackPacket.reasonCode
      //     }
      //     this.notifyListener()
      // }
      // 监听消息发送方法
      const packetFunction = (packet) => {
        console.log('监听消息发送状态', packet)
        updateMessageStatusBySendAck(packet)
        // state.messages.forEach((m) => {
        //   if (m.clientSeq == packet.clientSeq) {
        //     m.status = packet.reasonCode == 1 ? MessageStatus.Normal : MessageStatus.Fail
        //     return
        //   }
        // })
      }
      // 更新消息状态
      const updateMessageStatusBySendAck = (ackPacket) => {
        const message = findMessageWithClientSeq(ackPacket.clientSeq)
        // console.log(message)
        // console.log(message.message)
        // console.log(new BigNumber(ackPacket.messageID).toString())
        if (message) {
          message.messageID = new BigNumber(ackPacket.messageID).toString()
          message.messageSeq = ackPacket.messageSeq
          if (ackPacket.reasonCode === 1) {
            message.status = MessageStatus.Normal
          } else {
            message.status = MessageStatus.Fail
          }
          message.reasonCode = ackPacket.reasonCode
        }
      }
      // 通过messageID获取消息对象
      const findMessageWithMessageID = (messageID) => {
        if (!state.messages || state.messages.length <= 0) {
          return
        }
        for (let i = state.messages.length - 1; i >= 0; i--) {
          const message = state.messages[i]
          if (message.messageID == messageID) {
            return message
          }
        }
      }
      // 通过clientSeq获取消息对象
      const findMessageWithClientSeq = (clientSeq) => {
        if (!state.messages || state.messages.length <= 0) {
          return
        }
        for (let i = state.messages.length - 1; i >= 0; i--) {
          const message = state.messages[i]
          if (message.clientSeq === clientSeq) {
            return message
          }
        }
      }
      // 通过messageSeq获取消息对象
      const findMessageWithMessageSeq = (messageSeq) => {
        if (!state.messages || state.messages.length <= 0) {
          return
        }
        for (let i = state.messages.length - 1; i >= 0; i--) {
          const message = state.messages[i]
          if (message.messageSeq === messageSeq) {
            return message
          }
        }
      }
      // cmd监听
      const cmdListener = (message) => {
        console.log('cmd监听', message)
        const cmdContent = message.content
        const param = cmdContent.param
        if (cmdContent.cmd == 'messageRevoke') { //消息撤回
          let existMessage = findMessageWithMessageID(param.message_id)
          console.log('cmd监听', existMessage)
          if (existMessage) {
            existMessage.remoteExtra.revoke = true
            existMessage.remoteExtra.revoker = existMessage.fromUID;
            console.log(state.messages)
            state.messages = [...state.messages]
            scrollToBottom()
          }
        }
      }

      onMounted(() => {
        state.channelID = getQueryString("groupId")
        const conversation = WKSDK.shared().conversationManager.findConversation(new Channel(state.channelID, state
          .channelType))
        if (!conversation) {
          // 如果最近会话不存在，则创建一个空的会话
          WKSDK.shared().conversationManager.createEmptyConversation(new Channel(state.channelID, state
            .channelType))
        }

        // 同步消息
        getList()
        // 添加消息监听
        WKSDK.shared().chatManager.addMessageListener(messageFunction)
        // 添加消息发送监听
        WKSDK.shared().chatManager.addMessageStatusListener(packetFunction)
        // 添加cmd监听
        WKSDK.shared().chatManager.addCMDListener(cmdListener)

        // 获取订阅者
        // state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
        //   .channelType))
        // if (state.subscribers.length > 0) {
        //   console.log(state.subscribers)
        // } else {
        //   // 同步订阅者
        //   WKSDK.shared().channelManager.syncSubscribes(new Channel(state.channelID, state.channelType)).then(() => {
        //     state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
        //       .channelType))
        //     console.log(state.subscribers)
        //   })
        // }
        // WKSDK.shared().channelManager.addSubscriberChangeListener((channel) => {
        //   if (!new Channel(state.channelID, state.channelType).isEqual(channel)) {
        //     return
        //   }
        //   state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
        //     .channelType))
        // })
      })
      onUnmounted(() => {
        // 移除消息监听
        WKSDK.shared().chatManager.removeMessageListener(messageFunction)
        // 移除发送消息监听
        WKSDK.shared().chatManager.removeMessageStatusListener(packetFunction)
        // 移除cmd监听
        WKSDK.shared().chatManager.removeCMDListener(cmdListener)
      })
      // 返回
      const onClickLeft = () => {
        router.back()
      }



      return {
        moment,
        conversationList,
        state,
        onClickLeft,
        handleScroll,
        getComponent,
        locateMessage,
      }
    }
  }
</script>
<style scoped="scoped">
  .conversation-list {
    flex: 1;
    height: 100%;
    overflow-y: scroll;
    padding: 30px;
    padding-top: calc(100px + constant(safe-area-inset-top));
    padding-top: calc(100px + env(safe-area-inset-top));
  }
</style>